import * as React from 'react';
import Loading from './components/loading';
import Storage from './storage';
import ConfigService from './services/config-service';
import ePharmaServices from './services/epharma-services';
import keys from './util/keys';
import { AxiosRequestConfig } from 'axios';
import HomePage from './pages/home';
import StoreSearchPage from './pages/store-search';
import StoreList from './pages/store-search/list';
import CouponRegisterPage from './pages/coupon-register';
import Footer from './components/footer';
import Wrapper from './components/wrapper';
import { Switch, Route, BrowserRouter } from "react-router-dom";
import { IStoreResponse } from './interfaces/store';
import Login from './pages/login';
import CouponBuilder from './pages/coupon-builder';
import PrivateRoute from './components/private-route';

export default function App() {
    const [loading, setLoading] = React.useState(true);
    var [stores, setStores] = React.useState([] as IStoreResponse[]);
    var [infoMessage, setInfomessage] = React.useState('');

    const listRef = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => { authenticate(); }, []);

    const authenticate = async () => {
        const baseUrl = await ConfigService().getConfig(keys.ePharmaAuthenticationService);
        const authenticateUrl = await ConfigService().getConfig(keys.EndpointAuthenticationAuth);

        const username = await ConfigService().getConfig(keys.UserNameOauth);
        const password = await ConfigService().getConfig(keys.PasswordOauth);
        const clientId = await ConfigService().getConfig(keys.ClientId);

        setTimeout(async () => {
            const request = ePharmaServices(baseUrl);

            request.interceptors.request.use((config: AxiosRequestConfig) => {
                config.headers.common["username"] = username;
                config.headers.common["password"] = password;
                config.headers.common["client_id"] = clientId;

                return config;
            });

            const response = await request.get(authenticateUrl);

            setLoading(false);
            Storage.token.set(response.data.data.token);
        }, 2000);
    };

    return (
        <>
            <Wrapper>
                <BrowserRouter basename="/">
                    <Switch>
                        <Route path="/" exact component={() => <><HomePage /> {[stores = [], infoMessage = ""]} </>} />
                        {
                            !loading &&
                            <>
                                <Route
                                    path="/store-search"
                                    exact
                                    component={() =>
                                        <>
                                            <StoreSearchPage
                                                setInfoMessage={infoMessage => setInfomessage(infoMessage)}
                                                setStores={stores => {
                                                    setStores(stores);
                                                    listRef.current && listRef.current.scrollIntoView();
                                                }}
                                            />
                                            {
                                                (stores.length > 0 || infoMessage != "") &&
                                                <StoreList
                                                    setRef={ref => { listRef.current = ref }}
                                                    items={stores}
                                                    infoMessage={infoMessage}
                                                />
                                            }
                                        </>}
                                />
                                <Route
                                    path="/coupon-register"
                                    exact
                                    component={() => <><CouponRegisterPage /> {[stores = [], infoMessage = ""]} </>}
                                />
                                <Route path="/login" exact component={Login} />
                                <PrivateRoute path="/coupon-builder" component={CouponBuilder} />
                            </>
                        }
                    </Switch>
                </BrowserRouter>
            </Wrapper>
            <Footer />
            <Loading show={loading} />
        </>
    );
}